import React, { FC } from 'react';
import { CustomLabel, FlexContainer, InfoIcon, LockIcon, StatusCircle } from '../styles';
import Collapsible from './Collapsible';
import styled from 'styled-components';

type CollapsibleProps = {
  title: string;
  className?: string;
  children?: React.ReactNode;
  isShowInfoIcon?: boolean;
  isShowLockIcon?: boolean;
  isShowStatus?: boolean;
  inActive?: boolean;
  imgSrc?: string;
  collapsibleClassName?: string;
  isOpened?: boolean;
  titleAsNode?: React.ReactNode;
  customCollapsedData?: boolean;
  price?: string;
};

const CollapsibleWrapper = styled(FlexContainer)<Partial<CollapsibleProps>>`
  align-items: center;
  i {
    &.fa-chevron-down {
      margin-top: 4px;
    }
    &.fa-chevron-right {
      margin-top: 6px !important;
    }
  }
  .custom-collapsed-icon {
    display: inline-block;
    &.fa.fa-regular.charcoal-label {
      margin-top: 6px !important;
    }
  }
`;

const CollapsiblePanel: FC<CollapsibleProps> = ({
  title,
  children,
  className,
  isShowInfoIcon,
  isShowLockIcon,
  imgSrc,
  isShowStatus,
  inActive = false,
  collapsibleClassName,
  isOpened = true,
  titleAsNode,
  customCollapsedData = false,
  price,
  ...props
}) => {
  const [isOpen, toggleOpen] = React.useState(isOpened);
  return (
    <>
      <CollapsibleWrapper className={`label-description-row ${className}`} {...(props as CollapsibleProps)}>
        {isShowStatus && <StatusCircle heightWidth="18px" margin="0px 10px 0px 0px" inActive={inActive} />}
        {imgSrc && <img src={imgSrc} className="collapsed-header-icon" />}
        {/* {!customCollapsedData && (
                    <CustomLabel fontSize="22px" lineHeight="24px" fontWeight="600" className="collapsed-header-label">
                        {title}
                    </CustomLabel>
                )} */}
        {!customCollapsedData && (
          <CustomLabel fontSize="22px" lineHeight="24px" fontWeight="600" className="collapsed-header-label">
            {title}
          </CustomLabel>
        )}
        {isShowInfoIcon && <InfoIcon marginTop="4px" />}
        {isShowLockIcon && <LockIcon marginTop="2px" />}
        {!customCollapsedData && (
          <i
            className={`fa fa-regular ${isOpen ? 'fa-chevron-down' : 'fa-chevron-right'} charcoal-label clickable`}
            onClick={() => toggleOpen(!isOpen)}
          ></i>
        )}
        {customCollapsedData && (
          <FlexContainer justifyContent="space-between" alignItems="flex-start" spacing={30}>
            <div className="flex-auto-grow">
              <FlexContainer alignItems="flex-start">
                {titleAsNode ? (
                  titleAsNode
                ) : (
                  <CustomLabel fontSize="14px" lineHeight="18px" fontWeight="600" className="collapsed-header-label">
                    {title}
                  </CustomLabel>
                )}
                <i
                  className={`fa fa-regular ${isOpen ? 'fa-chevron-down' : 'fa-chevron-right'} charcoal-label clickable custom-collapsed-icon`}
                  onClick={() => toggleOpen(!isOpen)}
                ></i>
              </FlexContainer>
            </div>
            {price && parseFloat(price) > 0 && (
              <CustomLabel fontSize="14px" lineHeight="18px" fontWeight="600" className="collapsed-header-label">
                {'$' + price}
              </CustomLabel>
            )}
          </FlexContainer>
        )}
      </CollapsibleWrapper>
      <Collapsible isOpen={isOpen} className={collapsibleClassName}>
        {children}
      </Collapsible>
    </>
  );
};

export default CollapsiblePanel;
